<template>
  <v-card
    :width="isOpen ? 256 : 56"
    class="sidebar"
    v-if="isLogined"
    v-on:mouseleave="setHoverGroup('')"
  >
    <v-navigation-drawer class="blue-grey darken-4" dark permanent>
      <v-list>
        <!-- arrow -->
        <v-list-item
          link
          @click="
            isOpen = !isOpen
            closeGroupList()
            onChangeSidebar()
          "
          v-on:mouseover="setHoverGroup('')"
        >
          <v-list-item-icon>
            <v-icon :class="{'arrow-left': isOpen}">
              mdi-arrow-collapse-right
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content></v-list-item-content>
        </v-list-item>

        <!-- items -->
        <template v-for="(group, group_key) in groupList">
          <div
            :key="group_key"
            v-on:mouseover="setHoverGroup(group_key)"
            style="position:relative"
          >
            <v-list-item link :to="group.link">
              <v-list-item-icon>
                <v-icon>{{ group.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ group.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-btn
              icon
              class="accordion-btn"
              v-if="group.subGroupList && isOpen"
              @click="group.isOpen = !group.isOpen"
              :class="{'arrow-up': group.isOpen}"
            >
              <v-icon>mdi-chevron-down-circle</v-icon>
            </v-btn>
          </div>
          <div
            v-if="group.subGroupList"
            :key="'sub_' + group_key"
            class="accordion-item"
            :style="{
              maxHeight: group.isOpen
                ? Object.keys(group.subGroupList).length * 3 + 'rem'
                : '0',
            }"
          >
            <v-list-item
              link
              v-for="(subGroup, subGroup_key) in group.subGroupList"
              :key="subGroup_key"
              :to="subGroup.link"
              active-class="sidebar-sub-active"
            >
              <v-list-item-icon>
                <v-icon></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ subGroup.title }}</v-list-item-title>
            </v-list-item>
          </div>
          <!-- hover -->
          <template
            v-if="!isOpen && group.subGroupList && hoverGroup == group_key"
          >
            <v-card
              :key="'hover_' + group_key"
              class="hoverGroup"
              light
              v-on:mouseleave="setHoverGroup('')"
            >
              <v-list>
                <v-subheader>
                  <v-icon>{{ group.icon }}</v-icon>
                  {{ group.title }}
                </v-subheader>
                <v-list-item-group>
                  <v-list-item
                    v-for="(subGroup, subGroup_key) in group.subGroupList"
                    :key="subGroup_key"
                    @click="
                      page_to(subGroup.link)
                      setHoverGroup('')
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="subGroup.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      isOpen: this.$vuetify.breakpoint.name != 'xs' ? true : false,
      hoverGroup: '',
      groupList: {
        dashboard: {
          isOpen: false,
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          link: '/dashboard',
        },
        database: {
          isOpen: false,
          icon: 'mdi-database',
          title: 'Database',
          link: '/brains/list',
          subGroupList: {
            brains: {
              title: 'My list',
              link: '/brains/list',
            },
            share: {
              title: 'Shared with me',
              link: '/brains/share',
            },
            archives: {
              title: 'Archives',
              link: '/brains/archives',
            },
            designer: {
              title: 'Tags',
              link: '/brains/designer',
            },
          },
        },
        notebook: {
          isOpen: false,
          icon: 'mdi-notebook',
          title: 'Notebooks',
          link: '/notebooks/list',
          subGroupList: {
            notebook: {
              title: 'My list',
              link: '/notebooks/list',
            },
            share: {
              title: 'Shared with me',
              link: '/notebooks/share',
            },
            archives: {
              title: 'Archives',
              link: '/notebooks/archives',
            },
          },
        },
        studio: {
          isOpen: false,
          icon: 'mdi-movie-open',
          title: 'Studios',
          link: '/studios/list',
          subGroupList: {
            studio: {
              title: 'My list',
              link: '/studios/list',
            },
            share: {
              title: 'Shared with me',
              link: '/studios/share',
            },
            archives: {
              title: 'Archives',
              link: '/studios/archives',
            },
          },
        },
        repository: {
          isOpen: false,
          icon: 'mdi-earth',
          title: 'Repository',
          link: '/brains/public',
          subGroupList: {
            brains: {
              title: 'Brains',
              link: '/brains/public',
            },
            notebook: {
              title: 'Notebooks',
              link: '/notebooks/public',
            },
            studios: {
              title: 'Studios',
              link: '/studios/public',
            },
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      isLogined: 'auth/isLogined',
    }),
  },
  methods: {
    onChangeSidebar() {
      this.$emit('sidebar', this.isOpen)
    },
    closeGroupList() {
      for (const group in this.groupList) {
        if (this.groupList.hasOwnProperty(group)) {
          this.groupList[group]['isOpen'] = false
        }
      }
    },
    setHoverGroup(group) {
      this.hoverGroup = group
    },
  },
  mounted() {
    this.onChangeSidebar()
  },
}
</script>

<style lang="scss">
.sidebar {
  position: fixed;
  height: 100vh;
  top: 0;
  z-index: 1;
  margin-top: 48px;
  transition: 0.4s;
  aside {
    border-radius: 0 !important;
    overflow: visible;
    .mdi-arrow-collapse-right {
      transition: 0.4s;
      &.arrow-left {
        transform: rotate(-180deg);
        margin-left: 200px;
      }
    }
    .sidebar-active {
      color: #fff;
    }
    .hoverGroup {
      position: absolute;
      left: 56px;
      color: red;
      max-width: 200px;
      width: 200px;
      margin-top: -56px;
      i {
        font-size: 1rem;
        margin-left: -3px;
        margin-right: 3px;
      }
    }
    .accordion-btn {
      position: absolute;
      left: 210px;
      margin-top: -45px;
      &.arrow-up {
        transform: rotate(-180deg);
      }
    }
    .accordion-item {
      max-height: 0;
      overflow: hidden;
      transition: 0.4s ease-in-out;
    }
  }
  .sidebar-sub-active {
    color: #fff;
    background-color: rgba(84, 110, 122, 0.5);
  }
  .v-navigation-drawer__content {
    padding-bottom: 170px;
  }
}
</style>
